import React, { useEffect, useRef, useState } from "react";
import {
  Steps,
  Form,
  Col,
  Row,
  Divider,
  Input,
  Radio,
  Spin,
  Typography,
  Button,
} from "antd";
import AppoinmentType from "./components/AllAppoinments/AppoinmentType";
import "../../styles/modules/appoinment.less";
import Card from "antd/lib/card/Card";
import TimeSlot from "./components/AllAppoinments/TimeSlot";
import FinalInfo from "./components/AllAppoinments/FinalInfo";
import ButtonComponent from "../../components/Button/ButtonComponent";
import { Link, useHistory } from "react-router-dom";
import { APP_ROUTES } from "../../constants/Routes";
import { useDispatch, useSelector } from "react-redux";
import {
  doctorConsultationFeeInProgress,
  getScheduleInDefault,
  getScheduleInProgress,
  patientAddAppointmentInProgress,
} from "../../appRedux/Patient/Action/Action";
import FormInput from "../../components/Input/FormInput";
import IntlMessages from "../../util/IntlMessages";
import DoctorSelectAppointment from "./DoctorSelectBox";
import TimeSlotDates from "./components/AllAppoinments/TimeSlotDates";
import { useForm } from "antd/es/form/Form";
import AppointmentBookForm from "./components/AppointmentBookForm";
import SelectorsAppointment from "./Selectors";
import { getscheduleListEffect } from "../../appRedux/Patient/Sagas/Effect/patientAppointmentEffect";
import { LoadingOutlined, MessageOutlined } from "@ant-design/icons";
import ConsultationFee from "./consultancyFee";
import SelectBoxAppointment from "./SelectBox";
import moment from "moment";
import SelectFamilyMember from "../FamilyMember/SelectFamilyMember";
import { upperCase } from "lodash";
import { getDiseaseListInProgress } from "../../appRedux/doctor/actions/appointmentQuestions";
import Modal from "antd/lib/modal/Modal";
import AppointmentAnswerModel from "./AppointmentAnswerModel";
import { useLocation } from "react-router-dom";
import AppointmentQuestionsAnswerModel from "./AppointmentQuestionsAnswerModel";

const AddNewAppoinment = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [date, setDate] = useState("");
  const [slot, setSlot] = useState();
  const [doctorId, setDoctorId] = useState("");
  const [patientId, setPatientId] = useState("");
  const [addDiseaseModal, setAddDiseaseModal] = useState(false);
  const [diseaseName, setDiseaseName] = useState("");
  const [navigate, setNavigate] = useState(false);
  const patient_id = localStorage.getItem("patient_id");
  const doctor_id = localStorage.getItem("doctor_id");
  const organization_id = localStorage.getItem("org_id");
  useEffect(() => {
    const payLoad = {
      pagination: false,
      page: 1,
    };
    dispatch(getDiseaseListInProgress(payLoad));
  }, []);

  useEffect(() => {
    if (patient_id != "null") {
      setPatientId(patient_id);
      form.setFieldValue("patient_id", patient_id);
    }
  }, [patient_id]);
  useEffect(() => {
    if (doctor_id != "null") {
      setDoctorId(doctor_id);
      form.setFieldValue("doctor_id", doctor_id);
    }
  }, [doctor_id]);
  const { addAppointmentList } = useSelector(
    (state) => state.patientAppointment
  );
  const { consultationFee } = useSelector((state) => state.patientAppointment);

  const infee =
    consultationFee?.data?.data?.inperson_consultation_fee.toString();
  const telefee = consultationFee?.data?.data?.tele_consultation_fee.toString();
  const { getSchedule } = useSelector((state) => state.patientAppointment);
  const slotList = getSchedule?.data?.data || [];
  useEffect(() => {
    setSlot();
  }, [slotList]);

  const onFinish = (datas) => {
    console.log(datas);
    datas.slot_id = slot;
    let form = new URLSearchParams();
    form.append("date", datas.date);
    form.append("patient_id", datas.patient_id);
    form.append("doctor_id", datas.doctor_id);
    form.append("slot_id", datas.slot_id);
    form.append("start_time", datas.start_time);
    form.append("end_time", datas.end_time);
    form.append("reason", datas.reason);
    form.append("symptom", datas.symptom);
    form.append("consultation_type", datas.consultation_type);
    form.append("family_member_id", datas.family_member_id);
    form.append("organization_id", organization_id);
    if (location?.state?.disease_id) {
      form.append("qusetion_answer", location?.state?.qusetion_answer);
      form.append("disease_id", location?.state?.disease_id);
    }

    dispatch(patientAddAppointmentInProgress(form));
    setNavigate(true);
  };
  const disablePastDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  };
  const currentDate = moment(new Date()).format("YYYY-MM-DD");
  const [currentTime, setCurrentTime] = useState(moment().format("hh:mm A"));
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().format("hh:mm A"));
    }, 1000);
    dispatch(getScheduleInDefault());
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (date && doctorId) {
      const doctor_id = doctorId;
      dispatch(
        getScheduleInProgress({ date, doctor_id, currentDate, currentTime })
      );
      dispatch(doctorConsultationFeeInProgress(doctor_id));
    }
  }, [date, doctorId]);
  useEffect(() => {
    handleClearField();
  }, [patientId]);
  const handleClearField = () => {
    form.setFieldValue("family_member_id");
  };
  useEffect(() => {
    handleClearFieldDate();
  }, [doctorId]);
  const handleClearFieldDate = () => {
    form.setFieldValue("slot_id");
    form.setFieldValue("date");
    form.setFieldValue("consultation_type");
  };
  useEffect(() => {
    handleClearFieldSlot();
  }, [date]);

  const handleClearFieldSlot = () => {
    form.setFieldValue("slot_id");
  };

  const handlePage = () => {
    const formValue = form.getFieldsValue();
    setPatientId(formValue.patient_id);
    setDate(formValue.date);
    setDoctorId(formValue.doctor_id);
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 72,
      }}
      spin
    />
  );

  useEffect(() => {
    if (addAppointmentList?.success && navigate) {
      history.push("/appoinment/allappointments");
      setNavigate(false);
    }
  }, [addAppointmentList?.success && navigate]);

  useEffect(() => {
    if (getSchedule?.Error) {
      form.resetFields();
    }
  }, [getSchedule?.Error]);
  const onChange = (e) => {
    setSlot(e);
  };
  const handleAnswerType = (e) => {
    setAddDiseaseModal(true);
    // setDiseaseName(e.label);
  };
  return (
    <div
      className={
        getSchedule.success
          ? "app-with-card app-with-card-success"
          : "app-with-card app-with-card-failure"
      }
    >
      <Spin
        indicator={antIcon}
        spinning={addAppointmentList.inProgress || getSchedule.inProgress}
      >
        <Card className="appoinment-card">
          <Form
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            labelAlign="right"
            layout="horizontal"
            onFinish={onFinish}
            // title={"Addnew.appointment.label.AddNewAppointment"}
            form={form}
          >
            <div>
              <Row className="px-10 pt-10 Add-button">
                <Col>
                  <p className="header-tag mb-0">
                    {
                      <IntlMessages
                        id={"Addnew.appointment.label.AddNewAppointment"}
                      />
                    }
                  </p>
                </Col>
                <Col>
                  {location?.state?.qusetion_answer && (
                    <ButtonComponent
                      label={"Answers"}
                      onClick={handleAnswerType}
                    />
                  )}
                </Col>
              </Row>
              <Divider />
            </div>

            <Col xs={24} sm={24}>
              <SelectorsAppointment
                disabled={patient_id != "null" ? true : false}
                margin="mb-10"
                label={"Patient"}
                name={"patient_id"}
                placeholder={"Select your patient"}
                editMode={true}
                rules={[
                  {
                    required: true,
                    message: "Please enter your patient",
                  },
                ]}
                onChange={handlePage}
              />
            </Col>
            {patientId && (
              <Col xs={24} sm={24}>
                <SelectFamilyMember
                  margin="mb-10"
                  label={"Family member"}
                  name={"family_member_id"}
                  placeholder={"Select your family"}
                  editMode={true}
                  rules={[
                    {
                      required: true,
                      message: (
                        <IntlMessages id={"Please enter your family member"} />
                      ),
                    },
                  ]}
                  onChange={handlePage}
                  patient_id={patientId}
                />
              </Col>
            )}
            {/* <Col xs={24}>
              <SelectBoxAppointment
                margin="mb-10"
                label={<IntlMessages id={"Addnew.questions.diseases"} />}
                name={"diseases"}
                placeholder={"Select the diseases type"}
                editMode={true}
                // disabled={view}
                rules={[
                  {
                    required: true,
                    message: <IntlMessages id={"Select the diseases type"} />,
                  },
                ]}
                options={
                  getListDiseases?.data?.data?.map((val) => {
                    return { label: val.name, value: val.id };
                  }) || []
                }
                onChange={handleAnswerType}
              />
            </Col> */}
            <Col xs={24} sm={24}>
              <DoctorSelectAppointment
                disable={doctor_id != "null" ? true : false}
                margin="mb-10"
                label={"Doctor"}
                name={"doctor_id"}
                placeholder={"Select your doctor"}
                editMode={true}
                rules={[
                  {
                    required: true,
                    message: (
                      <IntlMessages id={"Addnew.appointment.validator.date"} />
                    ),
                  },
                ]}
                onChange={handlePage}
              />
            </Col>
            <Col xs={24} sm={24}>
              <FormInput
                labelCol={"24"}
                wrapperCol={"24"}
                type="date"
                placeholder="date"
                name="date"
                min={disablePastDate()}
                label={<IntlMessages id={"Addnew.appointment.label.date"} />}
                rules={[
                  {
                    required: true,
                    message: (
                      <IntlMessages id={"Addnew.appointment.validator.date"} />
                    ),
                  },
                ]}
                onChange={handlePage}
              />
            </Col>

            <div>
              {getSchedule.success ? (
                <div>
                  <Col xs={24} sm={24}>
                    <label>Slots</label>
                    <div className="slot-scroll">
                      <Radio.Group
                        name={"slot_id"}
                        className={"timeslot-container"}
                      >
                        {slotList.map((row) => (
                          <Radio.Button
                            name="slot_id"
                            disabled={upperCase(row?.isBooked) === "YES"}
                            className={`slot-button ${
                              slot === row.id ? "selected" : "shake"
                            } ${
                              upperCase(row?.isBooked) === "YES"
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => onChange(row.id)}
                          >
                            {moment(row?.start_time, ["h:mm A"]).format(
                              "h:mm A"
                            )}{" "}
                            -
                            {moment(row?.end_time, ["h:mm A"]).format("h:mm A")}{" "}
                          </Radio.Button>
                        ))}
                      </Radio.Group>
                    </div>

                    {!slot && (
                      <p style={{ color: "red" }}>Select the slot time</p>
                    )}
                    {/* <SelectBoxAppointment
                      margin="mb-10"
                      label={"Slot"}
                      name={"slot_id"}
                      placeholder={"Select your Slot"}
                      editMode={true}
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages id={"please enter your slot"} />
                          ),
                        },
                      ]}
                      options={slotList.map((row) => ({
                        label: `${moment(row?.start_time, ["h:mm A"]).format(
                          "h:mm A"
                        )} - ${moment(row?.end_time, ["h:mm A"]).format(
                          "h:mm A"
                        )}`,
                        value: row?.id,
                        disabled: upperCase(row?.isBooked) === "YES",
                      }))}
                      onChange={handlePage}
                    /> */}
                  </Col>

                  <Col xs={24} sm={24}>
                    <FormInput
                      labelCol={"24"}
                      wrapperCol={"24"}
                      type="text"
                      placeholder="reason"
                      name="reason"
                      label={
                        <IntlMessages id={"Addnew.appoinment.label.reason"} />
                      }
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages
                              id={"Addnew.appoinment.validator.reason"}
                            />
                          ),
                        },
                      ]}
                    />
                  </Col>
                  <Col xs={24} sm={24}>
                    <FormInput
                      labelCol={"24"}
                      wrapperCol={"24"}
                      type="text"
                      placeholder="symptoms"
                      name="symptom"
                      label={
                        <IntlMessages id={"Addnew.appoinment.label.symptoms"} />
                      }
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages
                              id={"Addnew.appointment.validator.symptoms"}
                            />
                          ),
                        },
                      ]}
                    />
                  </Col>
                  <Col xs={24} sm={24}>
                    <SelectBoxAppointment
                      margin="mb-10"
                      label={"Consultation Fees"}
                      name={"consultation_type"}
                      placeholder={"Enter your consultation fee"}
                      editMode={true}
                      rules={[
                        {
                          required: true,
                          message: (
                            <IntlMessages
                              id={"please enter your consultation fees"}
                            />
                          ),
                        },
                      ]}
                      options={[
                        {
                          value: "1",
                          label:
                            "inperson consultation fee is" + "     " + infee,
                        },
                        {
                          value: "2",
                          label: "tele consultation fee" + "    " + telefee,
                        },
                      ]}
                      onChange={handlePage}
                    />
                  </Col>

                  <Row className="space my-0 ">
                    <Col className="btn-pos">
                      <ButtonComponent
                        type="primary"
                        htmlType="Submit"
                        label="save"
                        className={"mb-0"}
                        disabled={!slot}
                      />
                      {/* 
                      <Link to={APP_ROUTES.ADDAPPOINTMENT}  >
                        <ButtonComponent type="primary" htmlType="Submit"  label="Next" />
                        </Link> */}
                    </Col>
                  </Row>
                </div>
              ) : (
                <span style={{ padding: "25px" }}>
                  -select doctor and date for schedule slot-
                </span>
              )}
            </div>
          </Form>
        </Card>
      </Spin>
      <Modal
        title={
          <Typography className="cancel-sales">
            {" "}
            <MessageOutlined /> &nbsp;
            {location?.state?.diseaseName}
          </Typography>
        }
        open={addDiseaseModal}
        width={"auto"}
        closable={false}
        footer={[
          <Button
            key="back"
            type="danger"
            onClick={() => {
              setAddDiseaseModal(false);
            }}
          >
            Close
          </Button>,
        ]}
      >
        <AppointmentQuestionsAnswerModel
          qusetion={location?.state?.qusetion_answer}
        />
      </Modal>
    </div>
  );
};

export default AddNewAppoinment;
